module.exports = __webpack_public_path__ + "img/Laetitia.0ac9cb26.jpg";